import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Clock, MessageCircle, Flame, Plus, Globe } from 'lucide-react';
import { Button } from './Button';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="precio" className="py-10 md:py-20 bg-stone-50" data-id="element-110">
      <div className="container mx-auto px-4 md:px-6" data-id="element-111">
        <div className="max-w-md mx-auto" data-id="element-112">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border border-gray-100 relative" data-id="element-113">
            <div className="bg-teal-600 p-3 md:p-6 text-center text-white" data-id="element-114">
              <h2 className="text-lg md:text-2xl font-bold mb-0.5 md:mb-2" data-id="element-115">
                Plantilla de Finanzas Personales
              </h2>
              <p className="opacity-90 text-[10px] md:text-sm" data-id="element-116">
                Oferta por tiempo limitado
              </p>
            </div>

            <div className="px-4 md:px-10 pt-3 md:pt-8 pb-5 md:pb-10" data-id="element-117">
              <div className="mb-2 flex justify-center" data-id="element-118">
                <img src="https://cdn.magicpatterns.com/uploads/aCbGv9Ta8whf6nYMwBmm7G/Logos_Verduleria_y_Fruteria_Simple_Verde_20260119_022532_0000.png" alt="Plantilla de Finanzas Personales en múltiples dispositivos" className="w-full max-w-[180px] md:max-w-none h-auto" data-id="element-119" />
              </div>

              <div className="mb-2 md:mb-6 bg-red-50 border border-red-100 rounded-lg p-1.5 md:p-3 flex items-center justify-center gap-1 md:gap-2 text-red-700 text-[10px] md:text-sm font-medium" data-id="element-120">
                <Clock className="w-3 h-3 md:w-4 md:h-4" data-id="element-121" />
                <span data-id="element-122">La oferta termina en:</span>
                <span className="font-mono font-bold text-xs md:text-base" data-id="element-123">
                  {String(timeLeft.hours).padStart(2, '0')}:
                  {String(timeLeft.minutes).padStart(2, '0')}:
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
              </div>

              <div className="flex flex-col items-center mb-3 md:mb-8" data-id="element-124">
                <div className="flex items-center gap-1.5 md:gap-2 mb-1.5 md:mb-3" data-id="element-125">
                  <Globe className="w-4 h-4 md:w-5 md:h-5 text-teal-600" data-id="element-126" />
                  <span className="text-xs md:text-sm text-gray-500 font-medium" data-id="element-127">
                    Precio adaptado a tu país
                  </span>
                </div>
                <p className="text-lg md:text-2xl font-bold text-gray-900 mb-1" data-id="element-128">
                  Precio especial con descuento
                </p>
                <span className="inline-block mt-1 md:mt-2 px-2.5 py-0.5 md:py-1 bg-teal-50 text-teal-700 text-[9px] md:text-xs font-bold rounded-full uppercase tracking-wide" data-id="element-129">
                  Pago Único • Acceso Inmediato
                </span>
              </div>

              <ul className="space-y-1.5 md:space-y-4 mb-3 md:mb-8" data-id="element-130">
                {['Plantilla Editable en Google Sheets', 'Gestión de Ingresos y Gastos', 'Control de Ahorros y Deudas', 'BONUS: Planificador Imprimible', 'BONUS: Video Tutorial Paso a Paso', 'Acceso de por vida'].map((item, index) => <li key={index} className="flex items-start gap-2 md:gap-3" data-id="element-131">
                    <Check className="w-3.5 h-3.5 md:w-5 md:h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-132" />
                    <span className="text-gray-700 text-xs md:text-base" data-id="element-133">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <Button href="https://pay.hotmart.com/R103783715V" fullWidth className="mb-2 md:mb-4 !text-sm md:!text-lg !py-3.5 md:!py-5 animate-pulse hover:animate-none shadow-xl hover:shadow-2xl" data-id="element-134">
                🌎 Ver precio en tu moneda
              </Button>

              <div className="hidden md:block mb-3 text-center" data-id="element-135">
                <p className="text-sm text-gray-700 mb-1" data-id="element-136">
                  💬 ¿Tuviste algún problema con el pago o con el acceso?
                </p>
                <a href="https://wa.link/ut4sjx" target="_blank" rel="noopener noreferrer" className="text-sm text-teal-600 hover:text-teal-700 font-medium underline inline-flex items-center gap-1" data-id="element-137">
                  <MessageCircle className="w-4 h-4" data-id="element-138" />
                  Escribinos por WhatsApp y te ayudamos en minutos
                </a>
              </div>

              <div className="hidden md:block text-center text-xs text-gray-400 mb-2 leading-relaxed" data-id="element-139">
                <p data-id="element-140">Producto digital – acceso inmediato.</p>
                <p data-id="element-141">
                  El acceso se envía automáticamente por email luego del pago.
                </p>
                <p data-id="element-142">No se envían productos físicos.</p>
              </div>

              <div className="flex items-center justify-center gap-1.5 text-[9px] md:text-xs text-gray-400" data-id="element-143">
                <ShieldCheck className="w-3 h-3 md:w-4 md:h-4" data-id="element-144" />
                <span data-id="element-145">Compra segura y garantizada</span>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-md mx-auto mt-5 md:mt-10" data-id="element-146">
          <div className="text-center mb-3 md:mb-4" data-id="element-147">
            <p className="text-sm md:text-base text-stone-500 flex items-center justify-center gap-1.5" data-id="element-148">
              <Plus className="w-4 h-4 text-teal-600" data-id="element-149" />
              <span data-id="element-150">
                También podés llevarte el{' '}
                <strong className="text-stone-700" data-id="element-151">Pack Completo</strong>
              </span>
            </p>
          </div>

          <div className="bg-stone-100 rounded-2xl md:rounded-3xl border border-stone-200 overflow-hidden" data-id="element-152">
            <div className="bg-stone-700 p-3 md:p-5 text-center text-white" data-id="element-153">
              <h3 className="text-base md:text-xl font-bold flex items-center justify-center gap-1.5 md:gap-2" data-id="element-154">
                <Flame className="w-4 h-4 md:w-5 md:h-5 text-orange-300" data-id="element-155" />
                Pack Completo
              </h3>
              <p className="opacity-80 text-[10px] md:text-sm mt-0.5" data-id="element-156">
                Plantilla de Finanzas + Diario de Prioridades
              </p>
            </div>

            <div className="p-4 md:p-8" data-id="element-157">
              <div className="flex gap-3 md:gap-5 mb-4 md:mb-6" data-id="element-158">
                <div className="w-28 md:w-40 flex-shrink-0" data-id="element-159">
                  <img src="https://cdn.magicpatterns.com/uploads/tTBi8siNHesren2vnNC7kf/WhatsApp_Image_2026-04-04_at_18.48.55.jpg" alt="Pack Completo - Diario de Prioridades" className="w-full h-auto rounded-lg" data-id="element-160" />
                </div>
                <div className="flex-1" data-id="element-161">
                  <p className="text-stone-600 text-xs md:text-sm leading-relaxed mb-2 md:mb-3" data-id="element-162">
                    No solo organizás tu dinero, también tu enfoque, tus hábitos
                    y tu disciplina para sostener el cambio.
                  </p>
                  <div className="flex items-center gap-1.5 mb-1" data-id="element-163">
                    <Globe className="w-3.5 h-3.5 md:w-4 md:h-4 text-teal-600" data-id="element-164" />
                    <span className="text-[10px] md:text-xs text-stone-500 font-medium" data-id="element-165">
                      Precio en tu moneda local
                    </span>
                  </div>
                  <p className="text-sm md:text-base font-bold text-stone-900" data-id="element-166">
                    Incluye descuento especial
                  </p>
                </div>
              </div>

              <p className="text-[10px] md:text-xs font-bold text-teal-700 uppercase tracking-wide mb-2" data-id="element-167">
                Incluye todo lo de la plantilla +
              </p>

              <div className="grid grid-cols-2 gap-x-2 gap-y-1 md:gap-y-2 mb-3 md:mb-5" data-id="element-168">
                {['Diario de Prioridades (162 pág.)', 'Ejercicios diarios de enfoque', 'Prioridades claras', 'Afirmaciones de autoestima', 'Revisión semanal y mensual', 'Diseño simple y agradable'].map((item, index) => <div key={index} className="flex items-start gap-1" data-id="element-169">
                    <Check className="w-3 h-3 md:w-4 md:h-4 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-170" />
                    <span className="text-stone-600 text-[10px] md:text-xs leading-tight" data-id="element-171">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div className="flex flex-wrap gap-1.5 md:gap-2 mb-4 md:mb-5" data-id="element-172">
                {['Mapa de Sueños', 'Plan de Acción 7 días', 'Hoja de Prioridades', 'Lista de Hábitos'].map((item, index) => <span key={index} className="inline-flex items-center gap-0.5 bg-teal-50 text-teal-700 px-2 py-0.5 rounded-full text-[9px] md:text-xs font-medium" data-id="element-173">
                    🎁 {item}
                  </span>)}
              </div>

              <Button href="https://pay.hotmart.com/T105411671H" fullWidth className="!bg-teal-600 hover:!bg-teal-700 !py-3 md:!py-5 !text-sm md:!text-lg shadow-xl hover:shadow-2xl !font-bold" data-id="element-174">
                🔥 Ver precio del pack en tu moneda
              </Button>

              <p className="text-center text-[9px] md:text-xs text-stone-400 mt-2" data-id="element-175">
                📄 PDF digital (162 páginas) • 📲 Acceso inmediato • 🖨️ Digital
                o para imprimir
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}